import { useRef } from 'react'

export const useScroll = () => {
  const ref = useRef<HTMLDivElement>()

  const scroll = () => {
    try {
      ref.current.scrollIntoView({
        behavior: 'smooth'
      })
    } catch (err) {
      console.warn(err)
    }
  }

  return { ref, scroll }
}
